export default class ListNotifications {
  constructor(notificationRepository) {
    this.notificationRepository = notificationRepository;
  }

  async execute(userId, params) {
    if (!userId) {
      throw new Error('User ID is required');
    }
    return this.notificationRepository.getNotifications(userId, params);
  }
} 